import { gql } from '@apollo/client';

const ME_QUERY = gql`
  query me {
    me {
      id
      firstName
      lastName
      username
      email
      isTestAccount
      canUseAiViewer
      roles
      group {
        id
        rolePermissions {
          editFacilityNotes
        }
      }
      isDisabled
    }
  }
`;

export default ME_QUERY;
